module.exports = __webpack_public_path__ + "img/bottom-bar-bg-1.6bb4d02c.png";